import React from 'react'

import { Outcome } from '@app/graphql/types'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

export type AdvancePaymentsCheckResultsProps = {
  check: UtilityBillAnalysisChecks['advancePayments']
}

export const AdvancePaymentsCheckResults = ({ check }: AdvancePaymentsCheckResultsProps) => {
  if (check.outcome === Outcome.Pass) {
    return null
  }

  return (
    <CheckResultsLayout>
      <CheckResultsLayout.Title>Vorauszahlungen</CheckResultsLayout.Title>
      <CheckResultsLayout.Description>
        Die von Mieterseite geleisteten Vorauszahlungen werden in der Abrechnung nicht
        berücksichtigt.
      </CheckResultsLayout.Description>
    </CheckResultsLayout>
  )
}
